import { BLACK, PRIMARY_COLOR, RED } from './colorConstants';
import { PRIMARY_FONT } from './fontConstants';

export const BUTTON_STYLES = {
  primary: {
    border: `1px solid ${PRIMARY_COLOR[70]}`,
    color: PRIMARY_COLOR[70],
    textTransform: 'none',
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[900],
    '&:hover': {
      backgroundColor: PRIMARY_COLOR[10],
    },
  },
  primarySmall: {
    border: `1px solid ${PRIMARY_COLOR[70]}`,
    color: PRIMARY_COLOR[70],
    width: '100px',
    height: '40px',
    textTransform: 'none',
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[500],
    '&:hover': {
      backgroundColor: PRIMARY_COLOR[10],
    },
  },
  primaryMedium: {
    border: `1px solid ${PRIMARY_COLOR[70]}`,
    color: PRIMARY_COLOR[70],
    width: '150px',
    height: '40px',
    textTransform: 'none',
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[900],
    '&:hover': {
      backgroundColor: PRIMARY_COLOR[10],
    },
  },
  primaryLarge: {
    border: `1px solid ${PRIMARY_COLOR[70]}`,
    color: PRIMARY_COLOR[70],
    width: '190px',
    height: '40px',
    textTransform: 'none',
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[900],
    '&:hover': {
      backgroundColor: PRIMARY_COLOR[10],
    },
  },
  danger: {
    border: `1px solid ${RED[50]}`,
    color: RED[50],
    width: '150px',
    height: '40px',
    textTransform: 'none',
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[900],
    '&:hover': {
      backgroundColor: RED[10],
      border: `1px solid ${RED[50]}`,
    },
  },
  contained: {
    backgroundColor: PRIMARY_COLOR[70],
    color: 'white',
    width: '100px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: PRIMARY_COLOR[80],
    },
    '&:disabled': {
      backgroundColor: BLACK[30],
      color: BLACK[60],
    },
  },
  cancel: {
    border: `1px solid ${PRIMARY_COLOR[70]}`,
    color: PRIMARY_COLOR[70],
    width: '100px',
    backgroundColor: 'white',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: PRIMARY_COLOR[10],
    },
  },
};

export default BUTTON_STYLES;
